module.exports = "<div class=modal-header><button type=button class=close ng-click=modalCtrl.dismiss()>&times;</button><h3>Ticket restrictions</h3></div><div class=modal-body><h4>{{restrictions.Description}}</h4><div ng-repeat=\"term in restrictions.Terms\"><h6><b>{{term.Key}}</b></h6><p>{{term.Value}}</p></div><div ng-show=routeRestrictions><h6><b>Route</b></h6><p>{{routeRestrictions}}</p></div></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=modalCtrl.close()>OK</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ukrail/rail-ticket-restrictions-modal/rail-ticket-restrictions-modal.html
// module id = 3584
// module chunks = 0